import NBType, { InferType } from '@netbase/nb-type'
import { TimeZone } from 'enums'

const DashboardOwnerInfoSchema = NBType.object().shape('DashboardOwnerInfoSchema', {
  /* @prop */
  id: NBType.number(),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  timeZone: NBType.enum(TimeZone)
  /* END */
})
export default DashboardOwnerInfoSchema
export type DashboardOwnerInfo = InferType<typeof DashboardOwnerInfoSchema>
// RESERVE BELOW
